import React from 'react';
import { stats } from '../data/siteData';
import './StatsTicker.css';

const StatsTicker = () => (
  <section className="stats-ticker-section" aria-label="Healthcare textile market metrics">
    <div className="stats-ticker" aria-hidden="true">
      <div className="ticker-track">
        {[...stats, ...stats].map(({ number, label, Icon, tone }, index) => (
          <div className="ticker-item" key={`${label}-${index}`}>
            <span className={`ticker-icon tone-${tone}`}>
              <Icon size={18} strokeWidth={1.8} />
            </span>
            <strong>{number}</strong>
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>

    <div className="container stats-grid">
      {stats.map(({ number, label, Icon, tone }, index) => (
        <article className="stat-box stagger-card" key={label} style={{ '--delay': `${index * 70}ms` }}>
          <span className={`icon-circle tone-${tone}`}>
            <Icon size={22} strokeWidth={1.8} aria-hidden="true" />
          </span>
          <strong>{number}</strong>
          <span>{label}</span>
        </article>
      ))}
    </div>
  </section>
);

export default StatsTicker;
